/**
 * Screen utility functions
 */

/**
 * Checks if the current screen size is considered small (mobile)
 * @param breakpoint The width threshold in pixels (default: 768)
 * @returns true if screen width is less than or equal to the breakpoint
 */
export const isSmallScreen = (breakpoint = 1024): boolean => {
  if (typeof window === 'undefined') return false; // SSR check
  return window.innerWidth <= breakpoint;
}; 